/**
 * Georgia Weather Network — Official Logo
 * Renders the custom brand logo (GA-shaped badge with lightning, wordmark, and radar imagery).
 * Kept as a component so we can swap the asset or add variants (mono/inverted) later
 * without touching every consumer.
 */
export default function Logo({ size = 44, showText = false, className = "", textClassName = "" }) {
  return (
    <div className={`inline-flex items-center gap-3 ${className}`}>
      <img
        src="/gwn-logo.png"
        alt="Georgia Weather Network"
        width={size}
        height={size}
        className="shrink-0 drop-shadow-[0_4px_14px_rgba(31,99,201,0.4)]"
        style={{ width: size, height: size, objectFit: "contain" }}
      />
      {showText && (
        <div className={`leading-tight ${textClassName}`}>
          <div className="font-oswald text-lg font-bold uppercase tracking-widest text-white sm:text-xl">
            Georgia <span className="text-[#1f63c9]">Weather</span> Network
          </div>
          <div className="hidden text-[10px] uppercase tracking-[0.3em] text-gray-400 sm:block">
            GAWX · 24/7 Live Coverage
          </div>
        </div>
      )}
    </div>
  );
}
